<div class="section-step__btn-back animate">
  <a (click)="goBack()" class="link-back prev_step">
    <div class="link-back__icon">
      <img src="assets/images/icons/arrow_back-24px.svg" />
    </div>
    Atrás
  </a>
</div>
